// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img{
  height: 100px;
}

.miniDeleteButton {
  background-color: white;
  color: red;
  width: 1px;
}

#takeTruffleButton {
  margin-bottom: 5px;
  background-color: orange;
}

`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B","sourcesContent":["img{\n  height: 100px;\n}\n\n.miniDeleteButton {\n  background-color: white;\n  color: red;\n  width: 1px;\n}\n\n#takeTruffleButton {\n  margin-bottom: 5px;\n  background-color: orange;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
